module.exports = __webpack_public_path__ + "static/media/hammer.a44e8821.JPG";